<template>
  <div class="topbar-container">
    <div class="customer-logo-container">
      <img class="customer-logo-img" :src="require('@/assets/logos/bancomontepio-logo-white.png')" alt="Banco Montepio" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PreviewAppTopBar'
})
</script>

<style lang="scss" scoped>
@import "@/styles/colors.scss";

.topbar-container {
  border-top: 14px solid $gorate-primary;
  background-color: $gorate-secondary;

  display: grid;
  grid-template-columns: 1fr;
  align-items: center;

  .customer-logo-container {
    text-align: center;
    padding: 25px 30px;

    .customer-logo-img {
      width: 15vw;
    }
  }
}

@media (max-width: 600px) {
  .topbar-container {
    .customer-logo-container {
      .customer-logo-img {
        width: 30vw;
      }
    }
  }
}
</style>
